var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var view = require('./view')

/**
 * Options
 * {
 *     tabsContentContainer: '',
 *     tabContentClass: ''
 *     tabsContainerClass: '',
 *     tabItemClass: '',
 *     selectedTabClass: ''
 * }
 *
 * @param  {[type]} )         {                             console.log('initialize the tab behavior')                    console.log(this.options)  } [description]
 * @param  {[type]} defaults: {                             tabsContentContainer:   '',                  tabContentClass: '',                                         tabsContainerClass: 'm-tabs',    tabItemClass: 'm-tabs-item',    selectedTabClass: 'is-active'  } [description]
 * @param  {[type]} onRender: function      ( [description]
 * @return {[type]}           [description]
 */
var TabBehavior = Marionette.Behavior.extend({
  defaults: {
    defaultTabSlug: false,
    tabsContentContainer: false,
    tabContentClass: '',
    tabsContainerClass: 'm-tabs',
    tabItemClass: 'm-tabs-item',
    selectedTabClass: 'is-active'
  },
  initialize: function () {

  },
  onRender: function () {
    // if there are no tabs defined, stop here
    if (!this.view.options.tabs) return false;
    if (!this.view.options.tabs.length) return false;

    var self = this
    var tabsCollection = this.view.options.tabs

    if (this.options.tabsContentContainer) {
      self.hideContentTabs()
    }

    self.deactivateTabs()

    // get the tabs view
    var tabsView = new view.TabLabelsContainer({
      collection: tabsCollection,
      className: this.options.tabsContainerClass,
      childViewOptions: {
        className: this.options.tabItemClass
      }
    })

    // show the tabs
    self.view.showChildView(self.options.tabsRegion, tabsView)
    tabsView.on('change', _.bind(self.onTabSwitch, self))
    // set default tab
    if (!self.options.defaultTabSlug) {
      var tabView = tabsView.children.findByModel(tabsCollection.first())
      self.onTabSwitch(tabView)
    }
    // console.log(tabsView.children)
    // console.log('firsttab')
    // var firstTab = this.view.options.tabs.first()
    // console.log(firstTab)
    // self.onTabSwitch({slug: firstTab.get('slug'), model: firstTab})

  },
  deactivateTabs: function () {
    var self = this
    var tabs = self.view.el.querySelectorAll('.' + self.options.tabsContainerClass + ' > li')
    _.forEach(tabs, function (tab) {
      tab.classList.remove(self.options.selectedTabClass)
    })
  },
  hideContentTabs: function () {
    var contentTabs = this.view.el.querySelectorAll(this.options.tabsContentContainer + ' > div')
    _.forEach(contentTabs, function (contentTab) {
      contentTab.classList.add('hidden')
    })
  },
  onTabSwitch: function (tabView) {
    var self = this
    //  console.log(tab.model.get('elementId'))
    // highlight active tab
    if (self.options.tabsContainerClass) {
      self.deactivateTabs()

      var activeTabEl = tabView.el
      activeTabEl.classList.add(self.options.selectedTabClass)
    // var activeTabEl = tab.model.el
    // var activeTab = self.view.el.querySelector('#' + tab.model.get('elementId'))
    // contentTab.classList.remove('hidden')
    }
    //
    if (self.options.tabsContentContainer) {
      self.hideContentTabs()
      var contentTab = self.view.el.querySelector('#' + tabView.model.get('elementId'))
      contentTab.classList.remove('hidden')
    }
    //
    this.view.trigger('tab:switch', {slug: tabView.model.get('slug'), model: tabView.model})
  }
})

module.exports = TabBehavior

/*
define(function (require) {
    'use strict'

    var Marionette = require('backbone.marionette')
    var TabCollectionView = require('./TabCollectionView')

    return Marionette.Behavior.extend({

        initialize: function () {
            if (!this.view.tabs) {
                throw new Error('Tried to add TabbedBehavior to a layout without a "tabs" region.')
            }
            if (!this.view.content) {
                throw new Error('Tried to add TabbedBehavior to a layout without a "content" region.')
            }
            if (!this.options.tabs) {
                throw new Error('Tried to add TabbedBehavior to a layout wihtout providing a "tabs" collection.')
            }
            this.currentView = null
        },

        defaults: {
            tabCollectionView: TabCollectionView,
            tabCls: '',
            tabContainerCls: 'tab-item-view',
            selectedTabCls: 'selected'
        },

        onRender: function () {

            var self = this

            var extendObject = {
                collection: this.options.tabs,
                className: this.options.tabContainerCls,
                childViewOptions: {
                    className: this.options.tabCls
                }
            }

            if (this.options.tabItemView) {
                extendObject.childView = this.options.tabItemView
            }
            var tabsView = new this.options.tabCollectionView(extendObject)

            this.view.tabs.show(tabsView)

            tabsView.on('change', function (tabView) {
                self.switchTabs(tabView)
            })

            var defaultTab

            if (this.options.defaultTab) {
                tabsView.children.forEach(function (childView) {
                    if (childView.model.id === self.options.defaultTab) {
                        defaultTab = childView
                    }
                })
            }
            if (!defaultTab) {
                defaultTab = tabsView.children.first()
            }

            if (defaultTab) {
                this.switchTabs(defaultTab)
            } else {
                this.listenToOnce(this.options.tabs, 'add', function () {
                    this.switchTabs(tabsView.children.first())
                }.bind(this))
            }
        },

        switchTabs: function (tabView) {

            var tab = this.options.tabs.findWhere({id: tabView.model.id})

            if (this.currentTab) {
                this.currentTab.$el.removeClass(this.options.selectedTabCls)
            }
            this.currentTab = tabView

            var options
            if (this.options.getOptions) {
                options = this.options.getOptions(tabView.model)
            } else if (this.options.options) {
                options = this.options.options
            }

            tabView.$el.addClass(this.options.selectedTabCls)
            var newView = new (tab.get('ContentView'))(options)
            this.view.content.show(newView)

            this.view.trigger('tab:switch', {tab: tab})
        }

    })
})

 */



// WEBPACK FOOTER //
// ./js/behaviors/tabs/behavior.js